export default {
    LOAD_EMPLOYEE(state, employee) {
        state.items = employee
    }
}